module.exports = __webpack_public_path__ + "img/eservoir.0d044479.svg";